<!--
@Create By Tim For 19/08/21
@文档详情容器组件
-->
<template>
  <div class="DataInfoContainer">
    <DataInfo
      :data="dataInfoList"
      :wordID="wordID"
    />
  </div>
</template>

<script>
import api from '../../config/api'
import DataInfo from '@/components/DataInfo/DataInfo'

export default {
  name: 'DataInfoContainer',
  data() {
    return {
      wordID: this.$route.params.id,
      dataInfoList: '',
    }
  },
  components: {
    DataInfo
  },

  created() {
    this.getDataInfo(this.$route.params.id)
  },

  mounted() {

  },

  methods: {
    getDataInfo(id) {
      this.$axios.get(
        api + 'portal/doc/' + id
      ).then(res => {
        this.dataInfoList = res
      })
    },
  },

}
</script>

<style scoped>
.DataInfoContainer {
  width: 1440px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/container/DataInfoContainer.vue